import React from 'react';
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Card,
  CardBody,
  Heading,
  Text,
  VStack,
} from '@chakra-ui/react';

const rowValue = (value) => value || '—';

const Row = ({ label, value }) => (
  <Text>
    <strong>{label}:</strong> {rowValue(value)}
  </Text>
);

const OrganizationBillingSection = ({ organization }) => (
  <Card>
    <CardBody p={0}>
      <Accordion allowToggle>
        <AccordionItem border="none">
          <AccordionButton py={4} px={6} _expanded={{ bg: 'gray.50' }}>
            <Box flex="1" textAlign="left">
              <Heading size="md">Billing Information</Heading>
            </Box>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel pb={5} px={6}>
            <VStack align="start" spacing={2}>
              <Row label="Billing company name" value={organization?.billing_company_name} />
              <Row label="Billing address" value={organization?.billing_address} />
              <Row label="Billing zip" value={organization?.billing_zip} />
              <Row label="Billing city" value={organization?.billing_city} />
              <Row label="Billing state" value={organization?.billing_state} />
              <Row label="Billing country" value={organization?.billing_country} />
              <Row label="Billing same as school" value={organization?.billing_same_as_org ? 'Yes' : 'No'} />
              <Row label="VAT or tax number" value={organization?.vat_or_tax_number} />
              <Row label="Currency" value={organization?.currency} />
              <Row label="Billing method" value={organization?.billing_method} />
              <Row label="Billing email" value={organization?.billing_email} />
              <Row label="Billing method (other)" value={organization?.billing_method_other} />
              <Row label="Reference person" value={organization?.reference_person} />
              <Row label="Reference number" value={organization?.reference_number} />
              <Row label="Cost center" value={organization?.cost_center} />
              <Row label="Billing notes" value={organization?.billing_notes} />
              <Row label="Peppol" value={organization?.peppol} />
              <Row label="GLN" value={organization?.gln} />
              <Row label="Organisationsnummer" value={organization?.organisationsnummer} />
            </VStack>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </CardBody>
  </Card>
);

export default OrganizationBillingSection;
